import { UseMutationProps } from "@lib/types/Api";
import { Provider } from "@lib/types/Provider";
import { Modal } from "antd";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import useIntl from "react-intl/lib/src/components/useIntl";
import ProviderForm from "../ProviderForm";

type Props = {
  openModal: boolean;
  toggleModal: (status?: boolean) => void;
  mutationQuery: UseMutationProps<Partial<Provider>>;
  provider?: Provider;
};

export default function ProviderModal(props: Props) {
  const { messages } = useIntl();
  const { openModal, toggleModal, provider } = props;

  const handleClose = useCallback(() => {
    toggleModal(false);
  }, [toggleModal]);

  return (
    <Modal
      title={
        <FormattedMessage
          id={provider ? "common.editTitle" : "common.createTitle"}
          values={{ title: messages["common.provider"] as string }}
        />
      }
      open={openModal}
      onCancel={handleClose}
      footer={null}
    >
      <ProviderForm {...props} provider={props.provider} />
    </Modal>
  );
}
